module.exports = __webpack_public_path__ + "static/the-sun-is-also-a-star-4309a2bdb927de50386566a5de2822eb.jpg";